import React, { useState } from 'react';

import { Search, X } from 'react-feather';

import styles from './CategorySearch.module.scss';

/**
 * Category picker grid + search bar for the business-side "browse my coupons
 * by category" screen. Ported from the swiper-based RN version into a
 * simple wrapping grid (no native-style horizontal paging needed on web).
 */
const CategoryList = ({ onSelectCategory, onChangeSearchText, categories, searchOnly }) => {
  const [searchText, setSearchText] = useState('');

  const clearSearch = () => {
    setSearchText('');
    onChangeSearchText('');
  };

  return (
    <div>
      {!searchOnly && (
        <div className={styles.categoryGrid}>
          {categories.map(item => (
            <button
              key={item.id}
              type="button"
              className={item.isSelected ? `${styles.categoryItem} ${styles.categoryItemSelected}` : styles.categoryItem}
              onClick={() => onSelectCategory(item.id)}
            >
              <span className={styles.categoryIcon} aria-hidden="true">
                🏷️
              </span>
              <span className={styles.categoryItemText}>{item.name}</span>
            </button>
          ))}
        </div>
      )}

      <div className={styles.searchBarWrap}>
        <Search size={18} className={styles.searchIcon} />
        <input
          type="text"
          placeholder="Search for coupon"
          value={searchText}
          onChange={e => {
            setSearchText(e.target.value);
            onChangeSearchText(e.target.value);
          }}
          className={styles.searchInput}
        />
        {searchText.length > 0 && (
          <button type="button" className={styles.clearBtn} onClick={clearSearch} aria-label="Clear search">
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default CategoryList;
